export const destroyDialog = (vm, callback, resourceName = "The resource") => {
  vm.$modal.show("dialog-base", {
    title: "Beräfta borttagning",
    text: `<strong>${resourceName}</strong> kommer att raderas premanent.`,
    buttons: [
      {
        title: "Nej",
        default: true,
        handler: () => {
          vm.$modal.hide("dialog-base");
        }
      },
      {
        title: "Ja",
        handler: callback
      }
    ]
  });
};

export const showMessageDialog = (vm, title, message, options) => {
  vm.$modal.show("dialog-base", {
    title: title,
    text: message,
    buttons: options
  });
};
